import { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Layout from '../components/Layout/Layout';
import { RootState } from '../redux/Store';
import authUser from '../utils/helpers/authUser';
import { Permissions } from '../constants';
import { useFindPermissions } from '../utils/helpers/useFindPermissions';

type PrivateRoutesProperties = {
  children?: any;
  requiredPermissions?: Permissions[];
};

const PrivateRoutes: FC<PrivateRoutesProperties> = ({
  children,
  requiredPermissions = [],
}) => {
  const perms = useFindPermissions();

  return perms.hasAnyPermission(requiredPermissions) ||
    authUser?.getJWTToken() ? (
    <Layout>{children || <Outlet />}</Layout>
  ) : (
    <Navigate to='/not-authorized' />
  );
};

export default PrivateRoutes;
